import React, { Component } from 'react';
import { BigNumber, ethers } from 'ethers';
import confetti from 'canvas-confetti';

import { getAvailableProviderWithChainId, getChainIdFromShortName, initProvider, nftAbi, getChainCurrencySymbolWithChainId, tokenAbi, zeroAddress, getChainSymbol } from '../../utils/config';
import { Contract, Provider } from 'ethers-multicall';
import moment from 'moment-timezone';
import { eventBus, isAddress } from '../../utils/tool';
import { convertIpfsUrlToGatewayUrl, getIpfsText, getRemoteUrlContent } from '../../utils/ipfs';
import { connect } from "react-redux"
import store from '../../store';
import { withTranslation } from 'react-i18next';

import copy from 'copy-to-clipboard';
// const confetti = require('canvas-confetti');
// import confetti from 'canvas-confetti'


// import '@sweetalert2/theme-dark/dark.scss';
import IpfsPanel from '../Staking/components/IpfsPanel/index'
import InviteConfirmModal from '../Staking/components/InviteConfirmModal/index'
import WhitelistModal from '../Staking/components/WhitelistModal/index'
import UserListTable from '../Staking/components/UserListTable/index'
import { Modal, Form } from 'react-bootstrap';
import SuccessModal from './SuccessModal';
import MintModal from './MintModal';
import NftCard from './nftCard';
import PaymentConfigPanel from './PaymentConfigPanel';
import { buildMintCall, formatPaymentAmount, multiplyPaymentAmount, normalizePaymentConfig, PAYMENT_MODE_ERC20, PAYMENT_MODE_NATIVE } from './paymentConfig';
import { NFT_FACTORY_BY_CHAIN_ID, nftFactoryLookupAbi, nftV2Abi } from './nftV2Config';
import { isNftConsoleAdmin, NFT_TEMPLATE_V2, resolveNftTemplateId, shouldShowPublicMintControls } from './templateAccess';
import { getWalletSnapshot } from '../../utils/walletProviders';
import ConsoleView from './ConsoleView';
import ConsoleDialog from './ConsoleDialog';
import StatusDialog from './StatusDialog';
import ConsoleToast from './ConsoleToast';
import MarketplaceGuideDialog from './MarketplaceGuideDialog';
import { getLocalizedWalletError } from './errorMessages';
import { buildMintPreview, extractMintedTokenIds } from './mintReceipt';
import { loadOwnedTokenIds } from './ownedTokenIds';
import { measureRpcLatency, RPC_LATENCY_INTERVAL_MS } from './rpcLatency';
import './nft-console.css';

moment.tz.setDefault('UTC') // global style

const createEmptyMintSuccessInfo = () => ({
    show: false,
    count: 0,
    tokenIds: [],
    items: [],
    remainingCount: 0,
})

class NFTConsoleOne extends Component {
    state = {
        data: {},
        tabData: [],
        tabContent: [],
        features: [],
        chain: '', // 公链
        contract: '', // 矿池地址
        account: '',
        ipfsInfo: {},
        stakeTokenInfo: {},
        rewardTokenInfo: {},
        poolInfo: {},
        showStakeModal: false,
        showTransferOwnershipModal: false,
        mintLoading: false,
        mintQuantity: 1,
        stakeAmountInput: 0, // 质押数量
        stakeMax: false, // 点了max按钮
        swalProps: {},
        toastProps: { show: false, message: '', tone: 'success', id: 0 },
        reawardLoading: false,// 领取奖励的loading
        currentProvider: null,
        rpcLatencyMs: null,
        rpcLatencyStatus: 'idle',
        walletProvider: null,
        walletName: '',
        showUnstakeModal: false, // 展示解除质押按钮
        stopRewardLoading: false, // 停止质押的loading
        enableForceWithdrawLoading: false, // 强制解除质押的loading
        showTimeDetail: false, // 是否展示时间详情
        showIpfsPanel: false, // 展示ipfs信息
        countdown: {
            type: 0,
            ct: '00:00:00' // 时 分 秒
        },
        showInviteConfirmModal: false, // 展示确认邀请modal
        showWhitelistModal: false, // 设置白名单
        params: {},
        urlPath: '', // 当前的路径 主机+域名+#+hash
        invitorList: [], // 当前用户的邀请人列表信息
        invitorTotalCount: 0,
        perPage: 10,
        isAdmin: false, // 是否是管理员
        stakeUserList: [], // 质押用户列表
        adminInfo: {}, // 管理员信息,
        networkName: '',
        tmpNewOwner: '',
        tmpNewOwnerLoading: false,
        notShowList: [

        ], // 不显示交易对的列表
        showMintModal: false, // 展示铸造modal  
        nftInfo: {}, // nft信息
        mintSuccessInfo: createEmptyMintSuccessInfo(),
        myNftList: [],
        myNftCount: 0,
        myNftPage: 0,
        myNftPerPageCount: 10,
        templateId: 1,
        loadingNft: true,
        nftLoadError: '',
        layoutVersion: 'modern',
        ownershipAction: 'transfer',
        showMarketplaceGuide: false
    }

    async initProvider() {
        let provider = null
        const chainId = this.state.chainId
        const injectedProvider = this.state.walletProvider || getWalletSnapshot().provider
        if (injectedProvider?.request) {
            try {
                const hexChainId = await injectedProvider.request({ method: 'eth_chainId' })
                const cid = parseInt(BigNumber.from(hexChainId).toString())
                if (chainId === cid) {
                    provider = new ethers.providers.Web3Provider(injectedProvider)
                }
            } catch (error) {
                console.warn('Unable to use selected wallet provider for current chain', error)
            }
        }
        if (!provider) {
            // 直接走获取provider的逻辑
            provider = await getAvailableProviderWithChainId(chainId)
        }

        this.activeRpcProvider = provider
        this.activeRpcChainId = Number(chainId)

        return provider
    }

    getMainSiteBaseUrl() {
        return (process.env.REACT_APP_FATSALE_URL || 'https://fatsale.org').replace(/\/+$/, '')
    }

    openExternalUrl(url) {
        window.open(url, '_blank', 'noopener,noreferrer')
    }

    openMainSiteMint() {
        const chain = encodeURIComponent(this.state.chain || '')
        const contract = encodeURIComponent(this.state.contract || '')
        this.openExternalUrl(`${this.getMainSiteBaseUrl()}/#/nft/mint/${contract}?chain=${chain}`)
    }

    openMarketplaceGuide() {
        this.setState({ showMarketplaceGuide: true })
    }

    openMarketplaceCreate() {
        const chain = encodeURIComponent(this.state.chain || '')
        const contract = encodeURIComponent(this.state.contract || '')
        this.openExternalUrl(`${this.getMainSiteBaseUrl()}/#/nft/marketplace/create?chain=${chain}&nftAddress=${contract}`)
    }

    openMarketplaceDocs() {
        const locale = String(this.props.i18n?.language || '').toLowerCase()
        const path = locale.startsWith('zh') ? '/zh/docs/nft/marketplace-create/' : '/docs/nft/marketplace-create/'
        this.openExternalUrl(`https://docs.fatsale.org${path}`)
    }

    openMarketplaceDemo() {
        this.openExternalUrl('https://market.fatsale.org/bsc/0x24bDCfA9F4817c1d9DE21704dF58fDF5bAA489F2')
    }

    startRpcLatencyMonitor() {
        if (this.rpcLatencyTimer) window.clearInterval(this.rpcLatencyTimer)
        this.rpcLatencyTimer = window.setInterval(() => {
            if (!document.hidden) this.updateRpcLatency()
        }, RPC_LATENCY_INTERVAL_MS)
    }

    async updateRpcLatency(provider) {
        const chainId = Number(this.state.chainId)
        if (!chainId || this.rpcLatencyRequest) return this.rpcLatencyRequest

        const requestId = ++this.rpcLatencyRequestId
        if (this.state.rpcLatencyMs === null && this.state.rpcLatencyStatus !== 'measuring') {
            this.setState({ rpcLatencyStatus: 'measuring' })
        }

        let measuredProvider = provider
        const request = (async () => {
            try {
                if (!measuredProvider) {
                    measuredProvider = this.activeRpcChainId === chainId
                        ? this.activeRpcProvider
                        : await this.initProvider()
                }
                const latencyMs = await measureRpcLatency(measuredProvider)
                if (!this.rpcLatencyUnmounted && requestId === this.rpcLatencyRequestId && Number(this.state.chainId) === chainId) {
                    this.setState({ rpcLatencyMs: latencyMs, rpcLatencyStatus: 'ready' })
                }
            } catch (error) {
                console.warn('Unable to measure current RPC latency', error)
                if (measuredProvider === this.activeRpcProvider) {
                    this.activeRpcProvider = null
                    this.activeRpcChainId = null
                }
                if (!this.rpcLatencyUnmounted && requestId === this.rpcLatencyRequestId && Number(this.state.chainId) === chainId) {
                    this.setState({ rpcLatencyMs: null, rpcLatencyStatus: 'failed' })
                }
            } finally {
                if (requestId === this.rpcLatencyRequestId) this.rpcLatencyRequest = null
            }
        })()

        this.rpcLatencyRequest = request
        return request
    }

    componentDidMount() {

        this.rpcLatencyUnmounted = false
        this.rpcLatencyRequestId = 0
        this.startRpcLatencyMonitor()

        this.setState({
            swalProps: {
                show: false,
                title: '',
                text: '',
            }
        })
        this.walletChangedHandler = this.walletChanged.bind(this)
        eventBus.addListener("walletChanged", this.walletChangedHandler)
        const wallet = getWalletSnapshot()
        this.setState({
            account: wallet.account || '',
            walletProvider: wallet.provider || null,
            walletName: wallet.walletName || '',
        }, () => this.fetchData())
    }



    componentWillUnmount() {
        this.rpcLatencyUnmounted = true
        this.rpcLatencyRequestId += 1
        this.rpcLatencyRequest = null
        if (this.rpcLatencyTimer) window.clearInterval(this.rpcLatencyTimer)
        eventBus.removeListener("walletChanged", this.walletChangedHandler)
    }



    walletChanged(v) {
        this.activeRpcProvider = null
        this.activeRpcChainId = null
        this.rpcLatencyRequestId += 1
        this.rpcLatencyRequest = null
        this.setState({
            account: v.account || '',
            walletProvider: v.provider || null,
            walletName: v.walletName || '',
            myNftList: v.account ? this.state.myNftList : [],
            myNftCount: v.account ? this.state.myNftCount : 0,
            myNftPage: v.account ? this.state.myNftPage : 0,
            rpcLatencyMs: null,
            rpcLatencyStatus: 'idle',
        }, () => {
            if (this.state.contract) this.fetchData()
        })
    }

    async detectTemplateId(provider, chainId, contractAddress) {
        let factoryTemplateId = 0
        let contractTemplateVersion = 0
        const factoryAddress = NFT_FACTORY_BY_CHAIN_ID[chainId]

        if (factoryAddress) {
            try {
                const factory = new ethers.Contract(factoryAddress, nftFactoryLookupAbi, provider)
                const info = await factory.nftMap(contractAddress)
                factoryTemplateId = Number(info[3].toString())
            } catch (e) {
                console.log('无法从Factory读取NFT模板ID', e)
            }
        }

        if (!factoryTemplateId) {
            try {
                const nft = new ethers.Contract(contractAddress, nftV2Abi, provider)
                contractTemplateVersion = Number((await nft.templateVersion()).toString())
            } catch (e) {
                // 旧模板没有 templateVersion，按 V1 兼容处理。
            }
        }

        return resolveNftTemplateId({ factoryTemplateId, contractTemplateVersion })
    }

    async fetchData() {
        // 获取url参数
        const query = new URL(window.location.href)
        const r = query.hash.replace('#/', '').split('/')
        const ps = r[1].split('?')
        let contract = ps[0]
        const hrefArr = (query.origin + '/' + query.hash).split('?')

        if (ps.length > 0) {
            const params = new URLSearchParams(ps[1])
            // 获取inviter
            const m = {}
            for (const [key, value] of params.entries()) {
                m[key] = value || ''
            }
            this.setState({
                params: m
            })
        }
        // 获取代币信息
        // 如果当前钱包和选择的公链一致, 则使用当前的provider
        // 如果不一致, 则自动选择provider
        const chainId = getChainIdFromShortName(r[0])
        const chainChanged = Number(this.state.chainId) !== Number(chainId)
        if (chainChanged) {
            this.activeRpcProvider = null
            this.activeRpcChainId = null
            this.rpcLatencyRequestId += 1
            this.rpcLatencyRequest = null
        }

        this.setState({
            chain: r[0],
            contract,
            urlPath: hrefArr[0],
            showStakeModal: false,
            showUnstakeModal: false,
            chainId,
            rpcLatencyMs: chainChanged ? null : this.state.rpcLatencyMs,
            rpcLatencyStatus: chainChanged ? 'idle' : this.state.rpcLatencyStatus,
            loadingNft: true,
            nftLoadError: ''
        }, async () => {

            try {

            const provider = await this.initProvider()
            this.updateRpcLatency(provider)
            const templateId = await this.detectTemplateId(provider, chainId, contract)

            // 获取矿池信息
            let ethcallProvider = new Provider(provider)
            ethcallProvider = await initProvider(ethcallProvider, chainId)

            const pool = new Contract(contract, nftAbi)

            const calls1 = [
                pool.name(),
                pool.symbol(),
                pool.creator(),
                pool._url(),
                pool.istheSame(),
                pool.isOnlyAdmin(),
                pool.maxSupply(),
                pool.feePerNFT(),
                pool.projectIpfsKey(),
                pool._userMintLimit(),
                pool.openInviterFee(),
                pool.enableInviter(),
                pool.lenOfInvitorRewardPercentList(),
                pool.totalSupply(),
                pool.owner()
            ]


            if (this.state.account) {
                calls1.push(pool._invitor(this.state.account))
                calls1.push(pool._userMintCount(this.state.account))
                calls1.push(pool._reward(this.state.account))
            }

            const res1 = await ethcallProvider.all(calls1)

            const calls2 = [
                pool.feeMode(),
                pool.feeCa()
            ]


            let nftInfo = {
                name: res1[0],
                symbol: res1[1],
                creator: res1[2],
                url: res1[3],
                isTheSame: res1[4],
                isOnlyAdmin: res1[5],
                maxSupply: res1[6],
                feePerNFT: res1[7],
                projectIpfsKey: res1[8],
                userMintLimit: res1[9],
                openInviterFee: res1[10],
                enableInvitor: res1[11],
                lenOfInvitorRewardPercentList: res1[12],
                totalSupply: res1[13],
                owner: res1[14],
                invitor: res1.length > 15 ? (res1[15] !== zeroAddress ? res1[15] : '') : '',
                userMintCount: res1.length > 16 ? res1[16] : 0,
                reward: res1.length > 17 ? res1[17].toString() / 1e18 : 0,
                invitorRewardPercentList: [],
                feeMode: 0,
                feeCa: '',
                feeToken: {},
                templateId,
                configVersion: 0,
                configCreatedBlock: 0,
                rewardRaw: BigNumber.from(0),
                rewardSymbol: getChainSymbol(chainId),
                supportsMutableUserMintLimit: false
            }

            if (templateId === NFT_TEMPLATE_V2) {
                const v2Contract = new ethers.Contract(contract, nftV2Abi, provider)
                const config = normalizePaymentConfig(await v2Contract.getMintPaymentConfig())
                nftInfo.feeMode = config.mode
                nftInfo.feeCa = config.tokenAddress
                nftInfo.feePerNFT = config.priceRaw
                nftInfo.configVersion = config.version
                nftInfo.configCreatedBlock = config.createdBlock

                try {
                    nftInfo.supportsMutableUserMintLimit = await v2Contract.supportsMutableUserMintLimit()
                } catch (e) {
                    // Earlier template 2 contracts do not expose mutable wallet limits.
                }

                if (config.mode === PAYMENT_MODE_ERC20) {
                    nftInfo.feeToken = await this.getTokenInfo(config.tokenAddress, provider, chainId, this.state.account, contract)
                    nftInfo.rewardSymbol = nftInfo.feeToken.symbol
                }

                if (this.state.account) {
                    const paymentAsset = config.mode === PAYMENT_MODE_NATIVE ? zeroAddress : config.tokenAddress
                    nftInfo.rewardRaw = await v2Contract.rewardOfAsset(this.state.account, paymentAsset)
                    nftInfo.reward = formatPaymentAmount(
                        nftInfo.rewardRaw,
                        config.mode === PAYMENT_MODE_NATIVE ? 18 : nftInfo.feeToken.decimals
                    )
                }
            } else {
                try {
                    const res2 = await ethcallProvider.all(calls2)
                    console.log('res22222', res2)
                    nftInfo.feeMode = parseInt(res2[0].toString())
                    nftInfo.feeCa = res2[1]
                    if (nftInfo.feeMode === PAYMENT_MODE_ERC20) {
                        const feeToken = await this.getTokenInfo(nftInfo.feeCa, provider, chainId, this.state.account, contract)
                        console.log(feeToken, 'feeToken')
                        nftInfo.feeToken = feeToken
                    }
                } catch (e) {
                    console.log('不支持feeMode')
                }
            }

            //  获取邀请比例列表
            if (nftInfo.lenOfInvitorRewardPercentList > 0) {
                const calls2 = []
                for (let i = 0; i < nftInfo.lenOfInvitorRewardPercentList; i++) {
                    calls2.push(pool.invitorRewardPercentList(i))
                }
                const res2 = await ethcallProvider.all(calls2)
                const iList = []
                res2.forEach((item, index) => {
                    iList.push(item.toString() / 100)
                })
                nftInfo.invitorRewardPercentList = iList
            } else {
                nftInfo.invitorRewardPercentList = []
            }


            // 如果开启了邀请功能, 则获取下级列表
            if (nftInfo.enableInvitor) {
                this.getInvitorList(1, templateId)
            }

            // this.state.poolInfo.owner.toLowerCase() === this.state.account.toLowerCase()
            const isAdmin = isNftConsoleAdmin({
                templateId,
                creator: nftInfo.creator,
                owner: nftInfo.owner,
                account: this.state.account,
            })

            if (isAdmin) {
                // 获取管理员相关信息
                this.getStakeListForAdmin(1, templateId)
            }

            // 获取我已铸造的nft
            this.getMyNftList(1)




            this.setState({
                nftInfo,
                isAdmin,
                templateId,
                loadingNft: false,
            })
            store.dispatch({
                type: 'setNftInfo',
                value: nftInfo
            })
            // 获取ipfs信息
            if (nftInfo.projectIpfsKey) {
                getIpfsText(nftInfo.projectIpfsKey)
                    .then(res => {
                        this.setState({
                            ipfsInfo: JSON.parse(res)
                        })
                        store.dispatch({
                            type: 'setMiningInfo',
                            value: JSON.parse(res)
                        })
                    })
            }
            } catch (error) {
                console.error('NFT console initialization failed', error)
                const errorMessage = error?.reason || error?.error?.message || error?.message || this.props.t('未知错误')
                this.setState({
                    loadingNft: false,
                    nftLoadError: errorMessage,
                })
            }
        })



    }

    async getMyNftList(page) {
        if (!this.state.account) {
            this.setState({ myNftList: [], myNftCount: 0, myNftPage: 0, pagePaginate: null })
            return
        }
        const provider = await this.initProvider()
        const c = new ethers.Contract(this.state.contract, nftAbi, provider)

        let ethcallProvider = new Provider(provider)
        ethcallProvider = await initProvider(ethcallProvider, this.state.chainId)

        const pool = new Contract(this.state.contract, nftAbi)
        console.log('myIdList1111', c, this.state.account)
        const ownedTokenResult = await loadOwnedTokenIds(c, this.state.account)
        const myIdList = ownedTokenResult.tokenIds
        if (ownedTokenResult.strategy === 'ranges') {
            console.warn('tokensOfOwner failed; loaded wallet NFT IDs with tokensOfOwnerIn ranges', ownedTokenResult.fastPathError)
        }
        console.log('myIdList', myIdList)
        const count = myIdList.length
        const offset = this.state.myNftPerPageCount
        const start = (page - 1) * offset





        let myNftList = []
        let myNftCalls = []
        let callIdList = []
        for (let i = 0; i < myIdList.length; i++) {
            if (i >= start && i < start + offset) {
                myNftCalls.push(pool.tokenURI(myIdList[i]))
                callIdList.push(myIdList[i])
            }
        }
        // console.log('nnnnn', myNftCalls)
        if (myNftCalls.length > 0) {
            console.log('nft calls')
            myNftList = await ethcallProvider.all(myNftCalls)
        }

        console.log('mynftlist', myNftList.length, myNftCalls.length)
        if (myNftList.length === myNftCalls.length) {
            const nftList = callIdList.map((item, ind) => {
                return {
                    id: parseInt(item.toString()),
                    url: myNftList[ind]
                }
            })
            console.log(nftList, 'nnnnn')
            this.setState({
                myNftList: nftList,
                myNftCount: count,
                myNftPage: page
            }, () => {
                this.generateMyNftsPagination()
            })
        }

        // // id和nft信息对上了
        // const nftList = myIdList.map((item, ind) => {
        //     return {
        //         id: parseInt(item.toString()),
        //         url: myNftList[ind]
        //     }
        // })

    }

    async getTokenInfo(tokenAddress, provider, chainId, currentWallet, miningContract) {
        let ethcallProvider = new Provider(provider)
        // await ethcallProvider.init()
        ethcallProvider = await initProvider(ethcallProvider, chainId)

        const token = new Contract(tokenAddress, tokenAbi)

        const call = [token.name(), token.symbol(), token.decimals(), token.totalSupply()]
        if (currentWallet) {
            call.push(token.allowance(currentWallet, miningContract))
            call.push(token.balanceOf(currentWallet))
        }
        const res = await ethcallProvider.all(call)
        const decimals = parseInt(res[2].toString())
        const d = Math.pow(10, decimals)

        let allowance = 0
        let balance = 0
        let balanceBigNumber = null
        if (currentWallet) {
            allowance = res[4].toString()
            balance = res[5].toString()
            balanceBigNumber = res[5] // 是一个bigNumber
        }


        return {
            name: res[0],
            symbol: res[1],
            decimals,
            totalSupply: res[3].toString() / d,
            address: tokenAddress,
            allowance,
            balance,
            balanceBigNumber,
        }
    }

    checkNetwork() {
        if (!this.state.account || !this.state.walletProvider) {
            this.showMessageModal({
                show: true,
                title: this.props.t('需要连接钱包'),
                text: this.props.t('请先连接钱包再继续操作'),
            })
            return false
        }
        if (this.state.chainId !== this.props.chainId) {
            this.showMessageModal({
                show: true,
                title: this.props.t('错误'),
                text: this.props.t('当前网络不匹配, 请连接CORE钱包').replace('{net}', (this.state.networkName || this.state.chain || '').toUpperCase()),
            })
            return false
        }
        return true
    }

    handleErr(e) {
        const errorText = getLocalizedWalletError(e, this.props.t)
        const rawMessage = [e?.reason, e?.message, e?.error?.message].filter(Boolean).join(' ').toLowerCase()
        if (rawMessage.includes('stale config')) {
            this.fetchData()
        }
        this.showMessageModal({
            show: true,
            title: this.props.t('错误'),
            text: errorText,
        })
    }


    getShortAddress(address) {
        if (!address) return ''
        return address.slice(0, 4) + "..." + address.slice(address.length - 4);
    }

    normalizeConsoleUser(item, fixedReward = false) {
        const reward = parseFloat(item.reward.toString() / 1e18)
        return {
            id: parseInt(item.id.toString()),
            addr: item.addr,
            inviter: item.inviterAddr,
            inviterCount: item.inviterCount.toString(),
            mintCount: parseInt(item.mintCount.toString()),
            reward: fixedReward ? reward.toFixed(2) : reward,
        }
    }

    async loadLegacyAdminUsersPage(pool, ethcallProvider, page, perPage) {
        const [count] = await ethcallProvider.all([pool.getUserCount()])
        const total = parseInt(count.toString())
        const calls = []
        for (let i = total - ((page - 1) * perPage) - 1; i >= 0; i--) {
            calls.push(pool.getUserById(ethers.BigNumber.from(i)))
            if (calls.length >= perPage) break
        }
        return {
            total,
            users: calls.length > 0 ? await ethcallProvider.all(calls) : [],
        }
    }

    async loadLegacyInvitedUsersPage(pool, ethcallProvider, page, perPage) {
        const [count] = await ethcallProvider.all([pool.inviterListsForUserTotal(this.state.account)])
        const total = parseInt(count.toString())
        const calls = []
        for (let i = total - ((page - 1) * perPage) - 1; i >= 0; i--) {
            calls.push(pool.inviterListsForUserPage(this.state.account, ethers.BigNumber.from(i)))
            if (calls.length >= perPage) break
        }
        return {
            total,
            users: calls.length > 0 ? await ethcallProvider.all(calls) : [],
        }
    }

    async getStakeListForAdmin(page, templateId = this.state.templateId) {
        if (!this.state.account) return

        const provider = await this.initProvider()
        let ethcallProvider = new Provider(provider)
        ethcallProvider = await initProvider(ethcallProvider, this.state.chainId)
        const pool = new Contract(this.state.contract, nftAbi)
        const perPage = this.state.perPage
        let result

        if (Number(templateId) === NFT_TEMPLATE_V2) {
            try {
                const v2Contract = new ethers.Contract(this.state.contract, nftV2Abi, provider)
                const pageResult = await v2Contract.getUsersPage((page - 1) * perPage, perPage)
                result = {
                    users: pageResult.users || pageResult[0],
                    total: parseInt((pageResult.total || pageResult[1]).toString()),
                }
            } catch (error) {
                console.warn('当前 V2 合约不支持批量用户分页，使用兼容读取', error)
            }
        }

        if (!result) {
            result = await this.loadLegacyAdminUsersPage(pool, ethcallProvider, page, perPage)
        }

        this.setState({
            adminInfo: { userCount: result.total },
            stakeUserList: result.users.map((item) => this.normalizeConsoleUser(item)),
        })
    }

    async getInvitorList(page, templateId = this.state.templateId) {
        if (!this.state.account) return

        const provider = await this.initProvider()
        let ethcallProvider = new Provider(provider)
        ethcallProvider = await initProvider(ethcallProvider, this.state.chainId)
        const pool = new Contract(this.state.contract, nftAbi)
        const perPage = this.state.perPage
        let result

        if (Number(templateId) === NFT_TEMPLATE_V2) {
            try {
                const v2Contract = new ethers.Contract(this.state.contract, nftV2Abi, provider)
                const pageResult = await v2Contract.getInvitedUsersPage(
                    this.state.account,
                    (page - 1) * perPage,
                    perPage
                )
                result = {
                    users: pageResult.users || pageResult[0],
                    total: parseInt((pageResult.total || pageResult[1]).toString()),
                }
            } catch (error) {
                console.warn('当前 V2 合约不支持批量邀请列表分页，使用兼容读取', error)
            }
        }

        if (!result) {
            result = await this.loadLegacyInvitedUsersPage(pool, ethcallProvider, page, perPage)
        }

        this.setState({
            invitorList: result.users.map((item) => this.normalizeConsoleUser(item, true)),
            invitorTotalCount: result.total,
            perPage,
        })
    }



    showMessageModal(info) {
        this.setState({
            swalProps: {
                show: false,
                title: '',
                text: '',
            }
        }, () => {
            this.setState({
                swalProps: {
                    ...info
                }
            })
        })

    }


    generateShareLink() {
        // http://localhost:3000/#/core/0x928D87B7c6Ea72a44E86d72990d199C9905202f9?invitor=0x928D87B7c6Ea72a44E86d72990d199C9905202f9
        const account = this.state.account || this.props.account
        return account ? `${this.state.urlPath}?invitor=${account}` : ''
    }


    getProgressBarWidth() {
        const total = Number(this.state.nftInfo?.totalSupply?.toString() || 0)
        const max = Number(this.state.nftInfo?.maxSupply?.toString() || 0)
        if (!Number.isFinite(max) || max <= 0) return '0.00'
        return Math.min(100, Math.max(0, (total / max) * 100)).toFixed(2)
    }


    showDoubleColumn() {
        // 展示成两列的样式
        let flag = true // 默认展示成两列
        if (this.state.nftInfo?.isOnlyAdmin === true) { // 仅项目方铸造, 简易页面, 用一列
            flag = false
        }
        // extra 没有值+没开邀请
        if (this.state.ipfsInfo?.extra?.length === 0 && this.state.nftInfo?.enableInvitor === false) {
            flag = false
        }
        return flag
    }


    async showSuccessInfo(receipt, requestedQuantity = 1) {
        try {
            const provider = await this.initProvider()
            const contract = new ethers.Contract(this.state.contract, nftAbi, provider)
            let tokenIds = extractMintedTokenIds(receipt, this.state.contract, this.state.account)

            if (tokenIds.length === 0) {
                const { tokenIds: ownedTokenIds } = await loadOwnedTokenIds(contract, this.state.account)
                tokenIds = ownedTokenIds
                    .slice(Math.max(0, ownedTokenIds.length - Math.max(1, Number(requestedQuantity) || 1)))
                    .map((tokenId) => tokenId.toString())
            }

            const preview = buildMintPreview(tokenIds)
            if (preview.count === 0) throw new Error('Mint receipt contained no token IDs')

            const items = preview.previewIds.map((id) => ({ id, url: '', name: '', description: '', loading: true }))
            this.setState({
                mintSuccessInfo: {
                    show: true,
                    count: preview.count,
                    tokenIds,
                    items,
                    remainingCount: preview.remainingCount,
                }
            })
            confetti({ particleCount: 100, spread: 160, zIndex: 10000000 })

            Promise.all(preview.previewIds.map(async (id) => {
                try {
                    const uri = await contract.tokenURI(id)
                    const content = await getRemoteUrlContent(uri)
                    const metadata = typeof content === 'string' ? JSON.parse(content) : content
                    return {
                        id,
                        url: metadata?.image ? convertIpfsUrlToGatewayUrl(metadata.image) : '',
                        name: metadata?.name || '',
                        description: metadata?.description || '',
                        loading: false,
                    }
                } catch (error) {
                    console.warn(`Unable to load metadata for minted NFT #${id}`, error)
                    return { id, url: '', name: '', description: '', loading: false }
                }
            })).then((loadedItems) => {
                this.setState((state) => {
                    if (state.mintSuccessInfo.tokenIds.join(',') !== tokenIds.join(',')) return null
                    return { mintSuccessInfo: { ...state.mintSuccessInfo, items: loadedItems } }
                })
            })
        } catch (error) {
            console.warn('Unable to build mint success preview', error)
            this.showMessageModal({
                show: true,
                title: this.props.t('成功'),
                text: this.props.t('铸造成功'),
                icon: 'success',
            })
        }
    }

    closeMintSuccess() {
        this.setState({ mintSuccessInfo: createEmptyMintSuccessInfo() })
    }

    viewMintedNfts() {
        this.closeMintSuccess()
        window.requestAnimationFrame(() => {
            document.getElementById('wallet-assets')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        })
    }

    async transferNft(tokenId, recipient) {
        if (!this.state.account) throw new Error('Wallet not connected')
        if (this.checkNetwork() === false) throw new Error('Network mismatch')

        const provider = await this.initProvider()
        const contract = new ethers.Contract(this.state.contract, nftAbi, provider.getSigner())
        const owner = await contract.ownerOf(tokenId)
        if (owner.toLowerCase() !== this.state.account.toLowerCase()) {
            throw new Error('Wallet is not token owner')
        }

        const transferMethod = 'safeTransferFrom(address,address,uint256)'
        await contract.callStatic[transferMethod](this.state.account, recipient, tokenId)
        const transaction = await contract[transferMethod](this.state.account, recipient, tokenId)
        const transferReceipt = await transaction.wait()
        await this.fetchData()
        return transferReceipt
    }

    // 生成我的nft的paginate
    generateMyNftsPagination() {

        const pageCount = Math.ceil(this.state.myNftCount / this.state.myNftPerPageCount)
        const page = this.state.myNftPage

        // 从第一页到最后一页
        const arr = []
        let pageIndex = -1
        for (let i = 1; i <= pageCount; i++) {
            arr.push({
                page: i,
                active: i === page,
                ellipsis: false, // 省略号
            })
            if (i === page) {
                pageIndex = i - 1
            }
        }
        // 如果长度超过13, 则需要省略号, 只保留前后5个
        if (pageCount > 13) {
            if (pageIndex < 5) {
                // 前面不需要省略号
                for (let i = 10; i < pageCount; i++) {
                    arr[i].ellipsis = true
                }
            } else if (pageIndex > pageCount - 6) {
                // 后面不需要省略号
                for (let i = 0; i < pageCount - 10; i++) {
                    arr[i].ellipsis = true
                }
            } else {
                // 前后都需要省略号
                for (let i = 0; i < pageCount; i++) {
                    if (i < pageIndex - 5) {
                        arr[i].ellipsis = true
                    } else if (i > pageIndex + 4) {
                        arr[i].ellipsis = true
                    }
                }
            }
        }

        // 去除已省略的部分, 只保留1个
        const arr2 = []
        let ellipsisCount = 0
        arr.forEach(item => {
            if (item.ellipsis) {
                if (ellipsisCount < 1) {
                    arr2.push(item)
                    ellipsisCount++
                }
            } else {
                arr2.push(item)
            }
        })



        console.log(arr2, 'page paginate')
        const res = {
            list: arr2,
            pageCount,
            currentPage: page
        }
        this.setState({
            pagePaginate: res
        })

    }

    getMaxMintQuantity() {
        const maxSupply = Number(this.state.nftInfo?.maxSupply?.toString() || 0)
        const totalSupply = Number(this.state.nftInfo?.totalSupply?.toString() || 0)
        const userLimit = Number(this.state.nftInfo?.userMintLimit?.toString() || 0)
        const userCount = Number(this.state.nftInfo?.userMintCount?.toString() || 0)
        const remainingSupply = Math.max(0, maxSupply - totalSupply)
        const remainingUser = userLimit > 0 ? Math.max(0, userLimit - userCount) : remainingSupply
        return Math.max(0, Math.min(remainingSupply, remainingUser))
    }

    changeMintQuantity(delta) {
        const max = this.getMaxMintQuantity()
        this.setState((state) => ({
            mintQuantity: Math.max(1, Math.min(max || 1, state.mintQuantity + delta))
        }))
    }

    getPaymentDetails() {
        const mode = this.state.nftInfo?.feeMode
        const decimals = mode === PAYMENT_MODE_NATIVE ? 18 : Number(this.state.nftInfo?.feeToken?.decimals || 18)
        const symbol = mode === PAYMENT_MODE_NATIVE
            ? getChainCurrencySymbolWithChainId(this.state.chainId)
            : (this.state.nftInfo?.feeToken?.symbol || this.props.t('其他代币'))
        const unitRaw = this.state.nftInfo?.feePerNFT || ethers.constants.Zero
        const totalRaw = multiplyPaymentAmount(unitRaw, this.state.mintQuantity)
        return {
            decimals,
            symbol,
            unitRaw,
            totalRaw,
            unit: formatPaymentAmount(unitRaw, decimals),
            total: formatPaymentAmount(totalRaw, decimals),
        }
    }

    copyValue(value) {
        if (!value) return
        const copied = copy(value)
        this.showToast(copied ? this.props.t('已复制到剪贴板') : this.props.t('复制失败，请重试'), copied ? 'success' : 'error')
    }

    showToast(message, tone = 'success') {
        this.setState((state) => ({
            toastProps: {
                show: true,
                message,
                tone,
                id: (state.toastProps?.id || 0) + 1,
            }
        }))
    }

    openProjectInfo() {
        if (this.checkNetwork() === false) return
        this.ipfsPanelRef?.setIpfsInfo({ ...this.state.ipfsInfo }).then(() => {
            this.setState({ showIpfsPanel: true })
        })
    }

    openDomainInfo() {
        this.showMessageModal({
            show: true,
            title: this.props.t('绑定独立域名'),
            content: <div className="domain-support-message">
                <p>{this.props.t('平台支持绑定独立域名并部署在单独的服务器中')}</p>
                <p>{this.props.t('此功能需要自行购买域名, 并额外支付部署费用以及后续维护费用')}</p>
                <p className="domain-support-message__contact">
                    <span>{this.props.t('具体请咨询')}</span>
                    <a
                        className="domain-support-link"
                        href="https://t.me/safu_contract"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span>{this.props.t('客服')}</span>
                        <i className="fa fa-external-link-alt" aria-hidden="true" />
                    </a>
                </p>
            </div>,
        })
    }

    openOwnershipTransfer(renounce = false) {
        this.setState({
            showTransferOwnershipModal: true,
            tmpNewOwner: renounce ? '0x000000000000000000000000000000000000dEaD' : '',
            ownershipAction: renounce ? 'renounce' : 'transfer',
        })
    }

    async submitOwnershipTransfer() {
        const targetAddress = this.state.ownershipAction === 'renounce'
            ? '0x000000000000000000000000000000000000dEaD'
            : this.state.tmpNewOwner
        if (!isAddress(targetAddress)) {
            this.showMessageModal({
                show: true,
                title: this.props.t('错误'),
                text: this.props.t('输入的地址格式不正确')
            })
            return
        }
        if (this.checkNetwork() === false || this.state.tmpNewOwnerLoading) return

        this.setState({ tmpNewOwnerLoading: true })
        try {
            const provider = await this.initProvider()
            const contract = new ethers.Contract(this.state.contract, nftAbi, provider.getSigner())
            const transaction = await contract.transferOwnership(targetAddress)
            await transaction.wait()
            await this.fetchData()
            this.setState({ showTransferOwnershipModal: false })
            this.showMessageModal({ show: true, text: this.props.t('操作成功'), icon: 'success' })
        } catch (error) {
            console.error('Ownership transfer failed', error)
            this.handleErr(error)
        } finally {
            this.setState({ tmpNewOwnerLoading: false })
        }
    }

    async handleMintClick() {
        if (!this.state.account) {
            this.showMessageModal({
                show: true,
                title: this.props.t('需要连接钱包'),
                text: this.props.t('请先连接钱包再铸造NFT'),
            })
            return
        }
        if (this.checkNetwork() === false) return

        const quantity = this.state.mintQuantity
        if (this.getMaxMintQuantity() < quantity) {
            this.showMessageModal({
                show: true,
                title: this.props.t('错误'),
                text: this.props.t('您的铸造数量已达上限')
            })
            return
        }

        const payment = this.getPaymentDetails()
        if (this.state.nftInfo.feeMode === PAYMENT_MODE_ERC20) {
            await this.stakeModalRef.setApproveInfo({
                amount: payment.totalRaw,
                mintQuantity: quantity,
                tokenDecimals: Number(this.state.nftInfo.feeToken.decimals),
                tokenName: this.state.nftInfo.feeToken.name,
                tokenSymbol: payment.symbol,
                chainId: this.state.chainId,
                stakeContract: this.state.contract,
                tokenAddress: this.state.nftInfo.feeToken.address,
                currentWallet: this.state.account,
                enableInviter: this.state.nftInfo.enableInvitor,
                stakeTokenBalanceBigNumber: this.state.nftInfo.feeToken.balanceBigNumber,
                templateId: this.state.templateId,
                configVersion: this.state.nftInfo.configVersion,
            })
            this.stakeModalRef.handleLogic()
            this.setState({ showMintModal: true })
            return
        }

        this.setState({
            mintLoading: true,
            mintSuccessInfo: createEmptyMintSuccessInfo()
        })

        try {
            const provider = await this.initProvider()
            const mintAbi = this.state.templateId === NFT_TEMPLATE_V2 ? nftV2Abi : nftAbi
            const contract = new ethers.Contract(this.state.contract, mintAbi, provider.getSigner())
            let receiver = zeroAddress
            if (this.state.nftInfo.enableInvitor && this.state.params.invitor) {
                if (this.state.params.invitor.toLowerCase() !== this.state.account.toLowerCase()) {
                    receiver = this.state.params.invitor
                }
            }
            const mintCall = buildMintCall({
                templateId: this.state.templateId,
                inviter: receiver,
                amount: ethers.BigNumber.from(quantity),
                value: '',
                configVersion: this.state.nftInfo.configVersion,
            })
            const transaction = await contract[mintCall.functionName](...mintCall.args, { value: payment.totalRaw })
            const receipt = await transaction.wait()
            await this.showSuccessInfo(receipt, quantity)
        } catch (error) {
            console.error('NFT mint failed', error)
            this.handleErr(error)
        } finally {
            await this.fetchData()
            this.setState({ mintLoading: false, mintQuantity: 1 })
        }
    }

    renderModernConsole() {
        const renouncing = this.state.ownershipAction === 'renounce'
        return <section className="nft-console-shell">
            <MintModal
                invitor={this.state.params.invitor || ''}
                onConfigStale={() => {
                    this.setState({ showMintModal: false })
                    this.showMessageModal({
                        show: true,
                        title: this.props.t('错误'),
                        text: this.props.t('铸造配置已更新，请确认新价格后重试'),
                    })
                    this.fetchData()
                }}
                onRef={(node) => { this.stakeModalRef = node }}
                handleClose={() => this.setState({ showMintModal: false })}
                ok={(receipt) => {
                    this.showSuccessInfo(receipt, this.state.mintQuantity)
                    this.fetchData()
                    this.setState({ mintQuantity: 1 })
                }}
                show={this.state.showMintModal}
            />

            <ConsoleDialog
                show={this.state.showTransferOwnershipModal}
                onClose={() => !this.state.tmpNewOwnerLoading && this.setState({ showTransferOwnershipModal: false })}
                title={renouncing ? this.props.t('放弃所有权') : this.props.t('转移所有权')}
                description={renouncing ? this.props.t('此操作不可撤销') : this.props.t('将合约管理权限转移到新地址')}
                icon={renouncing ? 'fa-exclamation-triangle' : 'fa-user-shield'}
                tone={renouncing ? 'danger' : 'default'}
                closeLabel={this.props.t('关闭')}
                className="ownership-dialog"
                footer={<>
                    <button type="button" className="console-button is-secondary" disabled={this.state.tmpNewOwnerLoading} onClick={() => this.setState({ showTransferOwnershipModal: false })}>{this.props.t('取消')}</button>
                    <button type="button" className={`console-button ${renouncing ? 'is-danger' : 'is-primary'}`} disabled={this.state.tmpNewOwnerLoading} onClick={() => this.submitOwnershipTransfer()}>
                        {this.state.tmpNewOwnerLoading && <i className="fa fa-spinner loading-css" />} {renouncing ? this.props.t('确认放弃所有权') : this.props.t('确认转移')}
                    </button>
                </>}
            >
                    {renouncing ? <div className="ownership-warning">
                        <i className="fa fa-exclamation-triangle" />
                        <strong>{this.props.t('此操作不可撤销')}</strong>
                        <p>{this.props.t('合约所有权将转移到销毁地址，之后无法再使用管理员功能')}</p>
                    </div> : <label className="console-field ownership-address-field">
                        <span>{this.props.t('新的管理员地址')}</span>
                        <input
                            value={this.state.tmpNewOwner}
                            onChange={(event) => this.setState({ tmpNewOwner: event.target.value.trim() })}
                            placeholder="0x..."
                        />
                    </label>}
            </ConsoleDialog>

            <MarketplaceGuideDialog
                show={this.state.showMarketplaceGuide}
                onClose={() => this.setState({ showMarketplaceGuide: false })}
                onCreate={() => this.openMarketplaceCreate()}
                onDocs={() => this.openMarketplaceDocs()}
                onDemo={() => this.openMarketplaceDemo()}
                t={this.props.t}
            />

            <StatusDialog {...this.state.swalProps} t={this.props.t} onClose={() => this.setState({ swalProps: { show: false, title: '', text: '' } })} />
            <ConsoleToast
                key={this.state.toastProps.id}
                {...this.state.toastProps}
                closeLabel={this.props.t('关闭')}
                onClose={() => this.setState((state) => ({ toastProps: { ...state.toastProps, show: false } }))}
            />
            <WhitelistModal
                poolAddress={this.state.contract}
                show={this.state.showWhitelistModal}
                handleClose={() => this.setState({ showWhitelistModal: false })}
                ok={() => {
                    this.fetchData()
                    this.setState({ showWhitelistModal: false })
                    this.showMessageModal({ show: true, title: this.props.t('成功'), text: this.props.t('设置成功'), icon: 'success' })
                }}
            />
            <InviteConfirmModal
                invitorRewardPercentList={this.state.nftInfo?.invitorRewardPercentList}
                fee={this.state.nftInfo?.openInviterFee}
                poolAddress={this.state.contract}
                show={this.state.showInviteConfirmModal}
                open={this.state.nftInfo?.enableInvitor}
                handleClose={() => this.setState({ showInviteConfirmModal: false })}
                ok={() => {
                    this.fetchData()
                    this.setState({ showInviteConfirmModal: false })
                    this.showMessageModal({ show: true, title: this.props.t('成功'), text: this.props.t('设置成功'), icon: 'success' })
                }}
            />
            <IpfsPanel
                onRef={(node) => { this.ipfsPanelRef = node }}
                handleClose={() => this.setState({ showIpfsPanel: false })}
                info={this.state.ipfsInfo}
                contract={this.state.contract}
                show={this.state.showIpfsPanel}
                ok={() => {
                    this.fetchData()
                    this.setState({ showIpfsPanel: false })
                }}
            />
            <SuccessModal
                {...this.state.mintSuccessInfo}
                handleClose={() => this.closeMintSuccess()}
                onViewAll={() => this.viewMintedNfts()}
            />
            <ConsoleView controller={this} />
        </section>
    }


    render() {

        if (this.state.layoutVersion === 'modern') return this.renderModernConsole()

        document.title = this.state.ipfsInfo?.project_name || this.state.nftInfo?.name || this.props.t('NFT铸造')

        return (
            <section style={{ paddingTop: this.state.nftInfo?.isOnlyAdmin === false ? '40px' : '0px' }} className="staking-area">

                <MintModal
                    invitor={this.state.params['invitor'] || ''}
                    onConfigStale={() => {
                        this.setState({ showMintModal: false })
                        this.showMessageModal({
                            show: true,
                            title: this.props.t('错误'),
                            text: this.props.t('铸造配置已更新，请确认新价格后重试'),
                        })
                        this.fetchData()
                    }}
                    onRef={node => this.stakeModalRef = node} handleClose={() => {
                        this.setState({
                            showMintModal: false
                        })
                    }} ok={(receipt) => {
                        // 质押完成
                        this.showSuccessInfo(receipt, this.state.mintQuantity)
                        this.fetchData()
                    }} show={this.state.showMintModal} />

                <Modal centered show={this.state.showTransferOwnershipModal} >
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.t('转移所有权')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ width: '100%' }}>
                            <div>
                                <Form.Control className="ipfs-info-input" value={this.state.tmpNewOwner} onChange={e => {
                                    this.setState({
                                        tmpNewOwner: e.target.value
                                    })
                                }} placeholder={this.props.t('请输入要转移到的地址')} />
                            </div>
                            <div style={{ marginTop: '10px' }}>
                                <div onClick={() => {
                                    if (!isAddress(this.state.tmpNewOwner)) {
                                        this.showMessageModal({
                                            show: true,
                                            title: this.props.t('错误'),
                                            text: this.props.t('输入的地址格式不正确')
                                        })
                                        return
                                    }
                                    if (this.state.tmpNewOwnerLoading) return // 防止重复点击   
                                    this.setState({
                                        tmpNewOwnerLoading: true
                                    }, async () => {
                                        try {
                                            const provider = await this.initProvider()
                                            const pool = new ethers.Contract(this.state.contract, nftAbi, provider.getSigner())
                                            const tx = await pool.transferOwnership(this.state.tmpNewOwner)
                                            await tx.wait()
                                            await this.fetchData()
                                            this.setState({
                                                showTransferOwnershipModal: false
                                            })
                                            this.showMessageModal({
                                                show: true,
                                                text: this.props.t('操作成功')
                                            })
                                        } catch (e) {
                                            console.log(e)
                                            this.handleErr(e)
                                        }

                                        this.setState({
                                            tmpNewOwnerLoading: false
                                        })
                                    })
                                }} className='btn btn-primary'>
                                    {this.state.tmpNewOwnerLoading && <span>
                                        <i style={{ 'fontSize': '16px', marginRight: '10px' }} className="fa fa-spinner loading-css"></i>
                                    </span>}
                                    {this.props.t('确定')}</div>
                                <div style={{ marginLeft: '10px' }} onClick={() => {
                                    this.setState({
                                        showTransferOwnershipModal: false
                                    })
                                }} className='btn btn-primary'>{this.props.t('取消')}</div>
                            </div>
                        </div>
                    </Modal.Body>

                </Modal>
                <StatusDialog {...this.state.swalProps} t={this.props.t} onClose={() => this.setState({ swalProps: { show: false, title: '', text: '' } })} />
                <WhitelistModal
                    poolAddress={this.state.contract}
                    show={this.state.showWhitelistModal}
                    handleClose={() => {
                        this.setState({
                            showWhitelistModal: false
                        })
                    }}
                    ok={() => {
                        this.fetchData()
                        this.setState({
                            showWhitelistModal: false
                        })
                        this.showMessageModal({
                            show: true,
                            title: this.props.t('成功'),
                            text: this.props.t('设置成功'),
                            icon: 'success'
                        })
                    }}
                />
                <InviteConfirmModal
                    invitorRewardPercentList={this.state.nftInfo?.invitorRewardPercentList}
                    fee={this.state.nftInfo?.openInviterFee}
                    poolAddress={this.state.contract}
                    show={this.state.showInviteConfirmModal}
                    open={this.state.nftInfo.enableInvitor}
                    handleClose={() => {
                        this.setState({
                            showInviteConfirmModal: false
                        })
                    }}
                    ok={() => {
                        this.fetchData()
                        this.setState({
                            showInviteConfirmModal: false
                        })
                        this.showMessageModal({
                            show: true,
                            title: this.props.t('成功'),
                            text: this.props.t('设置成功'),
                            icon: 'success'
                        })
                    }}
                />
                <IpfsPanel onRef={node => this.ipfsPanelRef = node} handleClose={() => {
                    this.setState({
                        showIpfsPanel: false
                    })
                }} info={this.state.ipfsInfo} contract={this.state.contract} show={this.state.showIpfsPanel} ok={(p) => {
                    // 调用合约
                    this.fetchData()
                    this.setState({
                        showIpfsPanel: false
                    })
                }} />

                <SuccessModal {...this.state.mintSuccessInfo}
                    handleClose={() => this.closeMintSuccess()}
                    onViewAll={() => this.viewMintedNfts()}
                />
                <div style={{ width: '100%' }} className="container">
                    {this.state.loadingNft && <div className="card no-hover staking-card text-center p-4 mb-4">
                        <i style={{ fontSize: '28px' }} className="fa fa-spinner loading-css mb-3"></i>
                        <div>{this.props.t('正在加载NFT信息')}</div>
                    </div>}
                    {this.state.nftLoadError && <div className="card no-hover staking-card text-center p-4 mb-4">
                        <h4>{this.props.t('加载NFT信息失败')}</h4>
                        <p className="mt-3 mb-3">{this.state.nftLoadError}</p>
                        <div>
                            <button type="button" className="btn btn-primary" onClick={() => this.fetchData()}>
                                {this.props.t('重试')}
                            </button>
                        </div>
                    </div>}
                    <div style={{ width: '100%' }} className="row">
                        <div className={"col-12 " + (!this.showDoubleColumn() ? 'col-md-6 offset-md-3' : 'col-md-7')}>
                            {this.state.nftInfo?.isOnlyAdmin === false && <div className="card no-hover staking-card single-staking">
                                <div className="stake-logo-box">
                                    {this.state.ipfsInfo?.logo && <div className='stake-logo-img stake-logo-img-left'>
                                        <img className='stake-logo-img-im' src={this.state.ipfsInfo.logo} alt='' />
                                    </div>}
                                    <div>
                                        <h3 className="m-0">{this.props.t('铸造')}
                                            &nbsp;  {this.state.nftInfo?.symbol}
                                        </h3>
                                    </div>
                                    {this.state.ipfsInfo?.logo && <div className='stake-logo-img stake-logo-img-right'>
                                        <img className='stake-logo-img-im' src={this.state.ipfsInfo.logo} alt='' />
                                    </div>}
                                </div>
                                <div className="tab-content mt-md-3" id="myTabContent">
                                    <div role="tabpanel">
                                        <div className="staking-tab-content">
                                            <div className="info-box d-flex justify-content-between mt-2">
                                                <div className="info-left">
                                                    <ul className="list-unstyled">
                                                        {this.state.contract && <li onClick={() => {
                                                            copy(this.state.contract)
                                                            this.showMessageModal({
                                                                show: true,
                                                                title: this.props.t('复制成功'),
                                                                html: `<p>${this.state.contract} </p>`,
                                                                icon: 'success'
                                                            })
                                                        }}>
                                                            <strong>
                                                                {this.props.t('合约')}: </strong>
                                                            {this.getShortAddress(this.state.contract)}
                                                            <i className="fa fa-copy user-list-table-copy"></i>
                                                        </li>}
                                                        {this.state.nftInfo?.maxSupply &&
                                                            <li>
                                                                <strong>
                                                                    {this.props.t('总量')}: </strong>
                                                                {this.state.nftInfo.maxSupply.toString()}</li>}
                                                        {this.state.nftInfo?.totalSupply && <li>
                                                            <strong>
                                                                {this.props.t('已铸造')}: </strong> {this.state.nftInfo.totalSupply.toString()}</li>}
                                                        {this.state.nftInfo?.totalSupply && <li><strong>
                                                            {this.props.t('您已铸造')}: </strong>
                                                            {parseInt(this.state.nftInfo.userMintLimit.toString()) > 0 && <span>
                                                                {this.state.nftInfo.userMintCount.toString()}/{this.state.nftInfo.userMintLimit.toString()}
                                                            </span>}
                                                            {parseInt(this.state.nftInfo.userMintLimit.toString()) === 0 && <span>
                                                                {this.state.nftInfo.userMintCount.toString()}
                                                            </span>}
                                                        </li>}

                                                    </ul>
                                                </div>
                                                <div className="info-right d-flex flex-column">
                                                    <ul className="list-unstyled">

                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="item-progress">
                                                <div style={{ height: '1.8rem', borderRadius: '1rem', backgroundColor: '#090A1A' }} className="progress mt-2 mt-md-2">
                                                    <div className="progress-bar" role="progressbar" style={{ width: this.getProgressBarWidth() + '%', backgroundColor: '#0047FF' }} aria-valuenow={parseInt(this.state.nftInfo?.totalSupply?.toString()) || 0} aria-valuemin={0} aria-valuemax={100}>  <span style={{ marginLeft: '10px', marginRight: '10px' }}>  {this.getProgressBarWidth()}% </span>  </div>
                                                </div>
                                                {/* <div className="progress-sale d-flex justify-content-between mt-3">
                                                    <span>{'0'}</span>
                                                    <span>{this.state.nftInfo?.maxSupply?.toString()} {this.state.nftInfo?.symbol}</span>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div className="input-box mt-4 d-flex flex-direction-row align-items-center justify-content-start">

                                    <div onClick={async () => {
                                        if (this.checkNetwork() === false) return

                                        // 检查铸造数量是否超过上限
                                        if (parseInt(this.state.nftInfo.userMintLimit.toString()) > 0) {
                                            if (parseInt(this.state.nftInfo.userMintCount) >= parseInt(this.state.nftInfo.userMintLimit.toString())) {
                                                this.showMessageModal({
                                                    show: true,
                                                    title: this.props.t('错误'),
                                                    text: this.props.t('您的铸造数量已达上限')
                                                })
                                                return
                                            }
                                        }

                                        if (this.state.nftInfo.feeMode === 1) {
                                            // 打开授权框

                                            this.stakeModalRef.setApproveInfo({
                                                amount: this.state.nftInfo.feePerNFT,
                                                tokenDecimals: parseInt(this.state.nftInfo.feeToken.decimals),
                                                tokenName: this.state.nftInfo.feeToken.name,
                                                tokenSymbol: this.state.nftInfo.feeToken.symbol,
                                                chainId: this.state.chainId,
                                                mintQuantity: 1,
                                                stakeContract: this.state.contract,
                                                tokenAddress: this.state.nftInfo.feeToken.address,
                                                currentWallet: this.state.account,
                                                enableInviter: this.state.nftInfo.enableInvitor,
                                                // stakeMax: this.state.stakeMax,
                                                // amountBigNumber: this.state.stakeMax ? this.state.stakeTokenInfo.balanceBigNumber : ethers.utils.parseUnits(this.state.stakeAmountInput + '', parseInt(this.state.stakeTokenInfo.decimals)),
                                                stakeTokenBalanceBigNumber: this.state.nftInfo.feeToken.balanceBigNumber,
                                                templateId: this.state.templateId,
                                                configVersion: this.state.nftInfo.configVersion,
                                            }).then(() => {
                                                // 调用流程, 先授权再质押, 中间有错误就停下来
                                                this.stakeModalRef.handleLogic() // 设置数量
                                            })

                                            this.setState({
                                                showMintModal: true
                                            })
                                            return
                                        }

                                        this.setState({
                                            mintLoading: true
                                        })



                                        this.setState({
                                            mintSuccessInfo: createEmptyMintSuccessInfo()
                                        })

                                        const provider = await this.initProvider()
                                        try {
                                            const mintAbi = this.state.templateId === NFT_TEMPLATE_V2 ? nftV2Abi : nftAbi
                                            const c = new ethers.Contract(this.state.contract, mintAbi, provider.getSigner())

                                            //todo 如果已经开启了邀请返利并且链接中有邀请参数, 则传入邀请者地址
                                            let receiver = zeroAddress
                                            if (this.state.nftInfo.enableInvitor && this.state.params['invitor']) {
                                                if (this.state.params['invitor'].toLowerCase() !== this.state.account.toLowerCase()) {
                                                    receiver = this.state.params['invitor']
                                                }

                                            }
                                            console.log(receiver, '邀请者地址')
                                            const mintCall = buildMintCall({
                                                templateId: this.state.templateId,
                                                inviter: receiver,
                                                amount: ethers.utils.parseUnits('1', 0),
                                                value: '',
                                                configVersion: this.state.nftInfo.configVersion,
                                            })
                                            const tx = await c[mintCall.functionName](...mintCall.args, { value: this.state.nftInfo.feePerNFT })
                                            const receipt = await tx.wait()
                                            this.showSuccessInfo(receipt, 1)




                                        } catch (e) {
                                            console.log(e)
                                            this.handleErr(e)
                                        }

                                        this.fetchData()


                                        this.setState({
                                            mintLoading: false
                                        })
                                    }} className="btn">
                                        {this.state.mintLoading && <span>
                                            <i style={{ 'fontSize': '16px', marginRight: '10px' }} className="fa fa-spinner loading-css"></i>
                                        </span>}
                                        {this.props.t('铸造')}</div>
                                    <div style={{ marginLeft: '10px', fontSize: '14px', fontWeight: 500 }}>{this.state.nftInfo?.feePerNFT && formatPaymentAmount(this.state.nftInfo.feePerNFT, this.state.nftInfo?.feeMode === PAYMENT_MODE_NATIVE ? 18 : this.state.nftInfo?.feeToken.decimals)} {this.state.nftInfo?.feeMode === PAYMENT_MODE_NATIVE ? getChainCurrencySymbolWithChainId(this.state.chainId) : this.state.nftInfo?.feeToken?.symbol}</div>
                                </div>

                            </div>}
                            {this.state.templateId === NFT_TEMPLATE_V2 && this.state.isAdmin && this.state.nftInfo?.configVersion > 0 && <PaymentConfigPanel
                                beforeSubmit={() => this.checkNetwork()}
                                contractAddress={this.state.contract}
                                currentConfig={{
                                    mode: this.state.nftInfo.feeMode,
                                    tokenAddress: this.state.nftInfo.feeCa,
                                    priceRaw: this.state.nftInfo.feePerNFT,
                                    version: this.state.nftInfo.configVersion,
                                    createdBlock: this.state.nftInfo.configCreatedBlock,
                                    token: this.state.nftInfo.feeToken,
                                }}
                                getProvider={() => this.initProvider()}
                                nativeSymbol={getChainCurrencySymbolWithChainId(this.state.chainId)}
                                onError={(e) => this.handleErr(e)}
                                onUpdated={() => this.fetchData()}
                                showMessage={(text) => this.showMessageModal({ show: true, title: this.props.t('成功'), text, icon: 'success' })}
                                t={this.props.t}
                            />}
                            {this.state.isAdmin && <div style={{ width: '100%' }} className='card no-hover staking-card mt-4'>
                                <p>{this.props.t('管理员控制')}</p>
                                <div className='mt-2'>
                                    <div onClick={() => {
                                        this.setState({
                                            showTransferOwnershipModal: true
                                        })
                                    }} style={{ 'width': '100%' }} className="btn btn-bordered-white btn-smaller">
                                        {this.props.t('转移所有权')}
                                    </div>
                                </div>
                                <div className='mt-2'>
                                    <div onClick={() => {
                                        this.setState({
                                            showTransferOwnershipModal: true,
                                            tmpNewOwner: '0x000000000000000000000000000000000000dEaD'
                                        })
                                    }} style={{ 'width': '100%' }} className="btn btn-bordered-white btn-smaller">
                                        {this.props.t('放弃所有权')}
                                    </div>
                                </div>

                                <div className='mt-2'>
                                    <div onClick={() => {
                                        if (this.checkNetwork() === false) return
                                        this.ipfsPanelRef.setIpfsInfo({
                                            ...this.state.ipfsInfo,
                                        }).then(() => {
                                            this.setState({
                                                showIpfsPanel: true
                                            })
                                        })
                                    }} style={{ 'width': '100%' }} className="btn btn-bordered-white btn-smaller">
                                        {this.props.t('设置项目信息')}
                                    </div>
                                </div>
                                {(window.location.href.indexOf('fatsale') > -1 || window.location.href.indexOf('localhost') > -1) && <div className='mt-2'>
                                    <div onClick={() => {
                                        if (this.checkNetwork() === false) return
                                        this.showMessageModal({
                                            show: true,
                                            title: this.props.t('绑定独立域名'),
                                            html: `<div><p>${this.props.t('平台支持绑定独立域名并部署在单独的服务器中')}</p><p>${this.props.t('此功能需要自行购买域名, 并额外支付部署费用以及后续维护费用')}</p><p>${this.props.t('具体请咨询')} <a target="_blank" rel="noopener noreferrer" href="https://t.me/safu_contract" >${this.props.t('客服')}</a></p></div>`,
                                        })
                                    }} style={{ 'width': '100%' }} className="btn btn-bordered-white btn-smaller">
                                        {this.props.t('绑定独立域名')}
                                    </div>
                                </div>}


                                {shouldShowPublicMintControls({
                                    isOnlyAdmin: this.state.nftInfo?.isOnlyAdmin,
                                }) && <>
                                    {!this.state.nftInfo?.enableInvitor && <div className='mt-2'>
                                        <div onClick={() => {
                                            if (this.checkNetwork() === false) return
                                            this.setState({
                                                showInviteConfirmModal: true
                                            })
                                        }} style={{ 'width': '100%' }} className="btn btn-bordered-white btn-smaller">
                                            {this.props.t('开启推广邀请')}
                                        </div>
                                    </div>}
                                    {this.state.nftInfo?.enableInvitor && <div className='mt-2'>
                                        <div onClick={() => {
                                            if (this.checkNetwork() === false) return
                                            this.setState({
                                                showInviteConfirmModal: true
                                            })
                                        }} style={{ 'width': '100%' }} className="btn btn-bordered-white btn-smaller">
                                            {this.props.t('设置推广返利等级')}
                                        </div>
                                    </div>}
                                    {this.state.nftInfo?.enableInvitor && <div className='mt-2'>
                                        <div onClick={() => {
                                            if (this.checkNetwork() === false) return
                                            this.setState({
                                                showWhitelistModal: true
                                            })
                                        }} style={{ 'width': '100%' }} className="btn btn-bordered-white btn-smaller">
                                            {this.props.t('设置白名单')}
                                        </div>
                                    </div>}
                                    <div className='mt-2'>
                                        <div onClick={() => {
                                            if (this.checkNetwork() === false) return
                                            copy(window.location.href)
                                            this.showMessageModal({
                                                show: true,
                                                title: this.props.t('复制成功'),
                                                html: `<p>${window.location.href} </p>`,
                                                icon: 'success'
                                            })
                                        }} style={{ 'width': '100%' }} className="btn btn-bordered-white btn-smaller">
                                            {this.props.t('复制铸造页面地址')}
                                        </div>
                                    </div>
                                </>}


                            </div>}
                        </div>
                        {this.showDoubleColumn() && <div className="col-12 col-md-5">
                            <div className="staking-items mt-4 mt-md-0">
                                {/* 我的邀请链接 */}
                                {this.state.nftInfo?.enableInvitor && <div className='card no-hover staking-card'>
                                    <div style={{ 'position': 'relative' }}>
                                        <input style={{ 'paddingRight': '65px' }} value={this.generateShareLink()} className="unstake-input" type="text" disabled />
                                        <div className="unstake-input-a">{this.props.t('复制')}</div>
                                        <div onClick={() => {

                                            copy(this.generateShareLink())
                                            this.showMessageModal({
                                                show: true,
                                                title: this.props.t('复制成功'),
                                                html: `<p>${this.generateShareLink()}</p>`,
                                                icon: 'success'
                                            })
                                        }} className="unstake-input-a unstake-input-a-mask">

                                        </div>
                                    </div>
                                    <p>{this.props.t('我的邀请链接')}</p>
                                </div>}

                                {this.state.nftInfo?.invitor && <div className='card no-hover staking-card mt-4'>
                                    <div style={{ 'position': 'relative' }}>
                                        <input style={{ 'padding-right': '65px' }} value={this.state.nftInfo.invitor} className="unstake-input" type="text" disabled />
                                        <div className="unstake-input-a">{this.props.t('复制')}</div>
                                        <div onClick={() => {

                                            copy(this.state.nftInfo.invitor)
                                            this.showMessageModal({
                                                show: true,
                                                title: this.props.t('复制成功'),
                                                html: `<p>${this.state.nftInfo.invitor}</p>`,
                                                icon: 'success'
                                            })
                                        }} className="unstake-input-a unstake-input-a-mask">

                                        </div>
                                    </div>
                                    <p>{this.props.t('我的邀请人')}</p>
                                </div>}

                                {this.state.ipfsInfo?.extra?.length > 0 && this.state.ipfsInfo.extra.map(item => {
                                    return <div key={'ext-' + item.name} className='card no-hover staking-card mt-4'>
                                        <h5>{item.name}</h5>
                                        <span>{item.content}</span>
                                    </div>
                                })}
                                {this.state.ipfsInfo.youtube && <div style={{ 'padding': '13px' }} className='mt-4 card no-hover staking-card'>
                                    <iframe className='card-img-top' width="100%" height="260" src={this.state.ipfsInfo.youtube} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                </div>}
                            </div>

                        </div>}
                        {this.state.isAdmin && shouldShowPublicMintControls({
                            isOnlyAdmin: this.state.nftInfo?.isOnlyAdmin,
                        }) && <div style={{ 'width': '100%' }} className='card no-hover staking-card mt-4'>
                            <h5 style={{ 'margin': '0' }}>{this.props.t('管理员数据面板')}</h5>
                            <div style={{ 'position': 'relative' }}>
                                <UserListTable
                                    key={'total-list-table'}
                                    total={this.state.adminInfo.userCount}
                                    // total={100}
                                    perPage={this.state.perPage}
                                    list={this.state.stakeUserList}
                                    changePage={(page) => {
                                        this.getStakeListForAdmin(page)
                                    }}
                                    copy={(addr) => {
                                        copy(addr)
                                        this.showMessageModal({
                                            show: true,
                                            title: this.props.t('复制成功'),
                                            html: `<p>${addr}</p>`,
                                            icon: 'success'
                                        })
                                    }}
                                    showReward={this.state.templateId !== NFT_TEMPLATE_V2}
                                />
                            </div>
                        </div>}
                        {this.state.invitorTotalCount > 0 && <div style={{ 'width': '100%' }} className='card no-hover staking-card mt-4'>
                            <h5 style={{ 'margin': '0' }}>{this.props.t('我的邀请列表')}</h5>
                            <div className='mt-2 d-flex flex-row' style={{ 'flexWrap': 'wrap' }} >
                                <div>{this.props.t("已邀请用户数")}: {this.state.invitorTotalCount}</div> &nbsp;&nbsp;
                                {this.state.nftInfo?.enableInvitor && <div>{this.props.t("已获得的推荐奖励")}: {this.state.nftInfo.reward} {this.state.templateId === NFT_TEMPLATE_V2 ? this.state.nftInfo.rewardSymbol : getChainSymbol(this.state.chainId)}</div>}&nbsp;&nbsp;
                            </div>
                            <div style={{ 'position': 'relative' }}>
                                <UserListTable
                                    key={'user-list-table'}
                                    total={this.state.invitorTotalCount}
                                    // total={100}
                                    perPage={this.state.perPage}
                                    list={this.state.invitorList}
                                    changePage={(page) => {
                                        this.getInvitorList(page)
                                    }}
                                    copy={(addr) => {
                                        copy(addr)
                                        this.showMessageModal({
                                            show: true,
                                            title: this.props.t('复制成功'),
                                            html: `<p>${addr}</p>`,
                                            icon: 'success'
                                        })
                                    }}
                                    showReward={this.state.templateId !== NFT_TEMPLATE_V2}
                                />
                            </div>
                        </div>}

                        {this.state.myNftList.length > 0 && <div style={{ 'width': '100%' }} className='card no-hover staking-card mt-4'>
                            <div>
                                <h5>{this.props.t('我的NFT')}</h5>
                            </div>
                            <div className='nft-scroll'>
                                {this.state.myNftList.length > 0 && this.state.myNftList.map(item => {
                                    return <NftCard info={item} />
                                })}
                            </div>
                            <div className='mt-2'>
                                {this.state.pagePaginate?.pageCount > 1 && <div className="d-flex flex-row custom-paginate">
                                    {this.state.pagePaginate.currentPage > 1 && <div onClick={() => {
                                        this.getMyNftList(this.state.pagePaginate.currentPage - 1)
                                    }} className="custom-paginate-item">
                                        <i style={{ 'fontSize': '12px' }} className="fas fa-chevron-left"></i>
                                    </div>}
                                    {this.state.pagePaginate.list.map((item, ind) => {
                                        if (item.ellipsis) {
                                            return <div key={'paginate-nft-ellipsis' + ind} className="custom-paginate-item">...</div>
                                        }
                                        return <div key={'paginate-nft' + ind} onClick={() => {
                                            this.getMyNftList(item.page)
                                        }} className={"custom-paginate-item " + (this.state.pagePaginate.currentPage === item.page ? 'custom-paginate-item-active' : '')} >
                                            {item.page}
                                        </div>
                                    })}
                                    {this.state.pagePaginate.currentPage < this.state.pagePaginate.pageCount && <div onClick={() => {
                                        this.getMyNftList(this.state.pagePaginate.currentPage + 1)
                                    }} className="custom-paginate-item">
                                        <i style={{ 'fontSize': '12px' }} className="fas fa-chevron-right"></i>
                                    </div>}
                                </div>}
                            </div>
                        </div>}
                    </div>
                </div>
            </section >
        );
    }
}

// export default StakingOne;

function mapStateToProps(state) {
    const { account, chainId } = state;
    return {
        account,
        chainId
        // text
    };
}

// export default ProjectSingle;
export default connect(mapStateToProps)(withTranslation()(NFTConsoleOne))
